import { gsap, ScrollTrigger } from "../utilities/gsap";

function JoinCommunity() {
    let el = document.getElementById("join-community"),
        content = null,
        statsItems = null,
        tl = null;

    if ( el && el.querySelectorAll(".stats-item").length ) {
        content = el.querySelector(".stats-content");
        statsItems = el.querySelectorAll(".stats-item");

        tl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top top',
                scrub: 1,
                pin: true,
                markers: false,
                id: 'join-community',
                toggleActions: "play none none reverse"
            }
        });

        tl.from(content, {
            scale: 0.75,
            autoAlpha: 0,
            immediateRender: true
        }, 0.25)

        statsItems.forEach((item, index) => {
            let image = item.querySelector(".stats-image"),
                detail = item.querySelector(".stats-detail"),
                properties = {};

            if ( index === 0 ) {
                properties = {
                    top: '50%',
                    left: '50%',
                    xPercent: -50,
                    yPercent: -50,
                    duration: 0.8,
                    immediateRender: true
                }
            } else if ( index === 1 ) {
                properties = {
                    top: '50%',
                    right: '50%',
                    xPercent: 50,
                    yPercent: -50,
                    duration: 0.8,
                    immediateRender: true
                }
            } else if ( index === 2 ) {
                properties = {
                    bottom: '50%',
                    left: '50%',
                    xPercent: -50,
                    yPercent: 50,
                    duration: 0.8,
                    immediateRender: true
                }
            }

            tl.from([item, image], {
                width: 350,
                height: 350,
                immediateRender: true
            }, 0)

            tl.from(item, properties, 0)
            
            tl.to(detail, {
                opacity: 1,
                duration: 0.2
            }, 0.5)
        });
    }

    ScrollTrigger.refresh()

    window.addEventListener("resize", () => {
        ScrollTrigger.refresh()
    })
}

export default function Home(){
    if ( !window.acf && window.innerWidth > 1024 ) setTimeout(() => {
        JoinCommunity()
    }, 500);
}